
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrueRelativeVectorProposal as ObiTrueRelativeVectorProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-true-relative-vector-proposal.js';
 
 
 

 
 export const ObiTrueRelativeVectorProposal = createComponent({
   react: React,
   tagName: 'obi-true-relative-vector-proposal',
   elementClass: ObiTrueRelativeVectorProposalElement,
   events: {
     
   }
  });
 
 